export default "__VITE_ASSET__CX9yeAfw__"